import {Record, List} from 'immutable';
import type {RecordOf} from 'immutable';

export type FieldGroupProps = {
  displayName: string;
  fieldIds: List<string>;
  /** Optional description shown under the group heading in the item form. */
  description?: string;
};

const FieldGroup: Record.Factory<FieldGroupProps> = Record(
  {
    displayName: '',
    fieldIds: List<string>(),
    description: undefined,
  } as FieldGroupProps,
  'FieldGroup'
);

export default FieldGroup;

export type FieldGroupType = RecordOf<FieldGroupProps>;
